/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * LESS_THAN_OR_EQUAL operator looks for values that are less than or equal to the given value.
 */
export interface LessThanOrEqualRevision {
    /** The value to compare against. */
    value: number;
}
